import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Login Submitted:', formData);
    // Add your login logic here (API call, Auth context update, etc.)
  };

  return (
    <div className="login-area py-5" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', backgroundColor: '#f9f9f9' }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-8">
            <div className="login-wrapper p-5 shadow-sm bg-white rounded">
              
              {/* Header Section */}
              <div className="login-header text-center mb-4">
                <h2 className="fw-bold mb-2">Welcome </h2>
                <p className="text-muted">Please sign in to your account</p>
              </div>

              {/* Form Section */}
              <form onSubmit={handleSubmit}>
                
                {/* Email Field */}
                <div className="form-group mb-3">
                  <label htmlFor="email" className="form-label fw-semibold">Email Address</label>
                  <div className="input-group">
                    <span className="input-group-text bg-light border-end-0">
                      <i className="fa-regular fa-envelope text-muted"></i>
                    </span>
                    <input
                      type="email"
                      className="form-control border-start-0 ps-0"
                      id="email"
                      name="email"
                      placeholder="name@example.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      style={{ boxShadow: 'none' }}
                    />
                  </div>
                </div>

                {/* Password Field */}
                <div className="form-group mb-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <label htmlFor="password" class="form-label fw-semibold">Password</label>
                  </div>
                  <div className="input-group">
                    <span className="input-group-text bg-light border-end-0">
                      <i className="fa-regular fa-lock text-muted"></i>
                    </span>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control border-start-0 ps-0 border-end-0"
                      id="password"
                      name="password"
                      placeholder="Enter your password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                      style={{ boxShadow: 'none' }}
                    />
                    <span 
                      className="input-group-text bg-light border-start-0" 
                      onClick={() => setShowPassword(!showPassword)}
                      style={{ cursor: 'pointer' }}
                    >
                      <i className={`fa-regular ${showPassword ? 'fa-eye-slash' : 'fa-eye'} text-muted`}></i>
                    </span>
                  </div>
                </div>

                {/* Remember Me & Forgot Password */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="rememberMe" />
                    <label className="form-check-label text-muted" htmlFor="rememberMe">
                      Remember me
                    </label>
                  </div>
                  <Link to="/forgot-password" style={{ textDecoration: 'none', fontSize: '14px', color: '#0d6efd' }}>
                    Forgot Password?
                  </Link>
                </div>

                {/* Submit Button */}
                <div className="d-grid mb-4">
                  <button type="submit" className="btn btn-dark btn-lg py-2">
                    Sign In
                  </button>
                </div>

                {/* Divider */}
                <div className="text-center position-relative mb-4">
                  <hr className="text-muted" />
                  <span className="position-absolute top-50 start-50 translate-middle bg-white px-3 text-muted" style={{ fontSize: '14px' }}>
                    Or continue with
                  </span>
                </div>

                {/* Social Login Buttons (Optional) */}
                <div className="d-flex gap-2 mb-4 justify-content-center">
                  <button type="button" className="btn btn-outline-secondary flex-grow-1">
                    <i className="fa-brands fa-google me-2"></i> Google
                  </button>
                  <button type="button" className="btn btn-outline-secondary flex-grow-1">
                    <i className="fa-brands fa-facebook-f me-2"></i> Facebook
                  </button>
                </div>

                {/* Sign Up Link */}
                <div className="text-center">
                  <p className="text-muted mb-0">
                    Don't have an account?{' '}
                    <Link to="/register" className="fw-bold" style={{ textDecoration: 'none', color: '#0d6efd' }}>
                      Create Account
                    </Link>
                  </p>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;